// ADDED Because theme doesn't have an option to autoloop slide videos - PA 20240323
const slideVideos = document.querySelectorAll(".slide video");

// Loop through each video and set its loop, autoplay, and muted attributes
slideVideos.forEach((video) => {
  video.loop = true;
  video.autoplay = true; // Play automatically
  video.muted = true; // Mute the video to ensure autoplay works in most browsers
});